import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

/** Raw settings document (GET /settings) + reload. */
export function useSettingsDoc() {
  const [settings, setSettings] = useState(null);
  const load = useCallback(async () => {
    const { data } = await api.get("/settings");
    setSettings(data);
  }, []);
  useEffect(() => { load(); }, [load]);
  return { settings, load };
}

/** Local editable copy of a settings section, re-synced whenever settings reload. */
export function useSyncedForm(settings, toForm) {
  const [form, setForm] = useState(() => toForm(settings));
  useEffect(() => {
    if (settings) setForm(toForm(settings));
  }, [settings, toForm]);
  return [form, setForm];
}

/** Pick `keys` from source, falling back to the default when the value is falsy. */
export function withDefaults(source, defaults) {
  return Object.fromEntries(Object.entries(defaults).map(([k, d]) => [k, source?.[k] || d]));
}
